import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'

import Breadcrumbs from '@/atoms/Breadcrumb'
import PageHero from '@/organisms/PageHero'
import ProductsGrid from '@/organisms/ProductsGrid/ProductsGrid'
import GTM from '@/services/GTM'
import { FansiKindExtended } from '@/ts/Global'
import FilterGroup from '@/ts/interfaces/global/FilterGroup'
import Product from '@/ts/Product'
import Presentation from '@/views/common/Presentation'

function ProductsGridView({
  products,
  isLoading,
  count,
  maxPrice,
  fansiKind,
  filters,
}: ProductsViewProps) {
  const { t } = useTranslation('global')

  const noResults = !isLoading && count <= 0
  const shouldDisplayContent = count > 0 && products.length > 0

  useEffect(() => {
    if (products.length > 0) {
      GTM.pushCategory(products, fansiKind)
    }
  }, [products.length])

  return (
    <div>
      <Breadcrumbs crumbs={[{ label: `${t(fansiKind)}` }]} className="mb-8" />
      <div className="space-y-10 md:space-y-20">
        <PageHero kind={fansiKind} />
        <Presentation
          withoutSort
          title="all_products"
          totalItems={count}
          noResults={noResults}
          filters={filters}
          maxPrice={maxPrice}
          shouldDisplayContent={shouldDisplayContent}
        >
          <ProductsGrid products={products} />
        </Presentation>
      </div>
    </div>
  )
}

interface ProductsViewProps {
  products: Product[]
  isLoading: boolean
  count: number
  maxPrice: number
  fansiKind: FansiKindExtended
  filters: FilterGroup
}

export default ProductsGridView
